function isFiniteNumberValue(value: number) {
  return Number.isFinite(value)
}

export function safeParseFloat(
  value: string | number | null | undefined,
  defaultValue: number,
): number
export function safeParseFloat(
  value: string | number | null | undefined,
): number | null
export function safeParseFloat(
  value: string | number | null | undefined,
  defaultValue?: number,
) {
  if (typeof value === 'number') {
    if (isFiniteNumberValue(value)) {
      return value
    }

    return defaultValue ?? null
  }

  if (typeof value === 'string' && value !== '') {
    const parsedValue = Number.parseFloat(value)
    if (isFiniteNumberValue(parsedValue)) {
      return parsedValue
    }
  }

  return defaultValue ?? null
}

export function safeParseInt(
  value: string | number | null | undefined,
  defaultValue: number,
): number
export function safeParseInt(
  value: string | number | null | undefined,
): number | null
export function safeParseInt(
  value: string | number | null | undefined,
  defaultValue?: number,
) {
  if (typeof value === 'number') {
    if (isFiniteNumberValue(value)) {
      return Math.round(value)
    }

    return defaultValue ?? null
  }

  if (typeof value === 'string' && value !== '') {
    const parsedValue = Number.parseInt(value)
    if (isFiniteNumberValue(parsedValue)) {
      return parsedValue
    }
  }

  return defaultValue ?? null
}
